import React, { useState } from "react";
import {
  Chip as initialChip,
  Typography,
  Modal,
  Button,
  Input,
  Popover as initialPopover,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import { REWARD_TYPES } from "../../constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchSavedFilter,
  addFilterByThunk,
  deleteSavedFilter,
} from "../../../../../actions/reportAction";
import ApplyFilterModal from "./ApplyFilterModal";
import { isFilterApplied } from "../../utils";
import { getRewardType } from "../../utils";
import moment from "moment";

const Chip = styled(initialChip).attrs()`
  height: 24px;
  margin-right: 16px;
  margin-top: 16px;
  background: ${(props) => props.theme.palette.light.c200};
  border-radius: 8px;
  .eui-chip-label {
    padding: 0 8px;
  }
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  .eui-chip-close {
    display: ${(props) => (!props.showDelete ? "" : "none")};
  }
`;

const Popover = styled(initialPopover).attrs()`
  overflow: visible;
  .eui-option-child {
    font-weight: 400 !important;
  }
`;

const FilterChipTypoGraphy = styled(Typography.CaptionText).attrs()`
  display: inline-block;
  text-transform: ${(props) => (props.lowercase ? "lowercase" : "capitalize")};
  margin-bottom: 0;
  font-weight: 400;
`;

const AppliedFilters = (props) => {
  const {
    initialColumns,
    activeTab,
    columns,
    setColumns,
    applyFilter,
    selectedCategory,
    selectedFilterIndex,
    setSelectedFilterIndex,
    reportsData,
    filterLoader,
    type,
    hideReportOptions,
    title,
  } = props;

  const [showSaveFilterModal, setShowSaveFilterModal] = useState(false);
  const [saveFilterName, setSaveFilterName] = useState("");
  const showDelete = selectedFilterIndex > -1;
  const reward_type = getRewardType(title);

  const handleResetFilter = () => {
    const newColumns = [...columns];
    newColumns.map((column) => {
      let filters = column?.filter?.filters;
      let filterType = column?.filter?.filterType;
      switch (filterType) {
        case "input":
        case "inputNumber":
          filters.map((ele) => {
            if (ele.selected) {
              ele.value = "";
              ele.inputNumber = false;
            }
          });
          break;
        case "select":
          filters?.value
            ? ((filters.value = ""), (filters.selectInputSelected = false))
            : null;
          break;
        case "date":
          if (filters?.startDate && filters?.endDate) {
            filters.startDate = "";
            filters.endDate = "";
            filters.dateSelected = false;
          }
          break;
      }
    });
    applyFilter(newColumns);
  };

  const removeSelectedTags = (column) => {
    let filters = column?.filter?.filters;
    let filterType = column?.filter?.filterType;
    switch (filterType) {
      case "input":
        setSelectedFilterIndex(-1);
        filters.map((ele) => {
          if (ele.selected) {
            ele.value = "";
          }
        });
        break;
      case "inputNumber":
        filters.map((ele) => {
          if (ele.selected) {
            ele.value = "";
          }
        });
        setSelectedFilterIndex(-1);
        break;
      case "select":
        filters?.value ? (filters.value = "") : null;
        setSelectedFilterIndex(-1);
        break;
      case "date":
        if (filters?.startDate && filters?.endDate) {
          filters.startDate = "";
          filters.endDate = "";
          filters.dateSelected = false;
        }
        setSelectedFilterIndex(-1);
        break;
    }
    let index = columns.findIndex((header) => header.name === column.name);
    const newColumns = [...columns];
    newColumns[index] = column;
    applyFilter(newColumns);
  };

  const renderInputFilterChip = (column, idx) => {
    const {
      label = "",
      filter: { filters = [] },
    } = column;
    return filters.map((ele, index) => {
      if (ele && ele.selected && ele.value) {
        return (
          <Typography component="div" key={index}>
            <Popover
              content={
                showDelete ? null : (
                  <>
                    <ApplyFilterModal
                      columns={columns}
                      index={idx}
                      applyFilter={applyFilter}
                      title={title}
                      type={type}
                      removeSelectedTags={removeSelectedTags}
                    />
                  </>
                )
              }
              offset={[0, 15]}
              placement="bottom-end"
              trigger="click"
              width={showDelete ? 0 : 360}
            >
              <Chip
                label={
                  <>
                    <FilterChipTypoGraphy color="dark" shade="c300">
                      {label}
                    </FilterChipTypoGraphy>{" "}
                    <FilterChipTypoGraphy color="dark" shade="c200" lowercase>
                      {ele.operation?.toLowerCase()}
                    </FilterChipTypoGraphy>{" "}
                    <FilterChipTypoGraphy color="dark" shade="c300" lowercase>
                      {ele?.value?.length > 22 ? (
                        <>{ele?.value?.toLowerCase()?.slice(0, 22)}...</>
                      ) : (
                        ele?.value?.toLowerCase()
                      )}
                    </FilterChipTypoGraphy>
                  </>
                }
                onDelete={() => {
                  removeSelectedTags(column);
                }}
                variant="fill"
                showDelete={showDelete}
              />
            </Popover>
          </Typography>
        );
      }
    });
  };

  const renderSelectFilterChip = (column, idx) => {
    const {
      label = "",
      filter: { filters: { operation = "", value = "" } = {} } = {},
    } = column;
    if (value) {
      return (
        <Popover
          content={
            showDelete ? null : (
              <>
                <ApplyFilterModal
                  columns={columns}
                  index={idx}
                  applyFilter={applyFilter}
                  title={title}
                  type={type}
                  removeSelectedTags={removeSelectedTags}
                />
              </>
            )
          }
          offset={[0, 15]}
          placement="bottom-end"
          trigger="click"
          width={showDelete ? 0 : 360}
        >
          <Chip
            label={
              <div className="">
                <FilterChipTypoGraphy color="dark" shade="c300">
                  {label}
                </FilterChipTypoGraphy>{" "}
                <FilterChipTypoGraphy color="dark" shade="c200" lowercase>
                  {operation}
                </FilterChipTypoGraphy>{" "}
                <FilterChipTypoGraphy color="dark" shade="c300">
                  {value?.value?.replace("_", " ")}
                </FilterChipTypoGraphy>
              </div>
            }
            onDelete={() => {
              removeSelectedTags(column);
            }}
            variant="fill"
            showDelete={showDelete}
          />
        </Popover>
      );
    }
  };

  const renderDateFilterChip = (column, idx) => {
    const {
      label = "",
      filter: {
        filters: {
          operation = "is between",
          startDate = "",
          endDate = "",
        } = {},
      } = {},
    } = column;
    if (startDate && endDate) {
      return (
        <>
          <Popover
            content={
              showDelete ? null : (
                <>
                  <ApplyFilterModal
                    columns={columns}
                    index={idx}
                    applyFilter={applyFilter}
                    title={title}
                    type={type}
                    removeSelectedTags={removeSelectedTags}
                  />
                </>
              )
            }
            offset={[0, 15]}
            placement="bottom-end"
            trigger="click"
            width={showDelete ? 0 : 360}
          >
            <Chip
              label={
                <>
                  <FilterChipTypoGraphy color="dark" shade="c300">
                    {label}
                  </FilterChipTypoGraphy>{" "}
                  <FilterChipTypoGraphy color="dark" shade="c200" lowercase>
                    {operation}
                  </FilterChipTypoGraphy>{" "}
                  <FilterChipTypoGraphy color="dark" shade="c300">
                    {moment(startDate, "YYYY-MM-DD").format("MMM D, YYYY")}
                  </FilterChipTypoGraphy>{" "}
                  <FilterChipTypoGraphy color="dark" shade="c200">
                    {" - "}
                  </FilterChipTypoGraphy>{" "}
                  <FilterChipTypoGraphy color="dark" shade="c300">
                    {moment(endDate, "YYYY-MM-DD").format("MMM D, YYYY")}
                  </FilterChipTypoGraphy>
                </>
              }
              onDelete={() => {
                removeSelectedTags(column);
              }}
              variant="fill"
              showDelete={showDelete}
            />
          </Popover>
        </>
      );
    }
  };

  const renderFilterChips = () => {
    let filterChips = "";
    return columns.map((column, index) => {
      switch (column?.filter?.filterType) {
        case "input":
          filterChips = renderInputFilterChip(column, index);
          break;
        case "inputNumber":
          filterChips = renderInputFilterChip(column, index);
          break;
        case "select":
          filterChips = renderSelectFilterChip(column, index);
          break;
        case "date":
          filterChips = renderDateFilterChip(column, index);
          break;
        default:
          filterChips = null;
          break;
      }
      return filterChips;
    });
  };

  const saveFilter = () => {
    const filterData = {
      name: saveFilterName,
      label: saveFilterName,
      tableHeader: columns,
      reward_type: reward_type,
      selectedCategory: selectedCategory,
    };
    props.addFilterByThunk(JSON.stringify(filterData), reward_type);
    handleResetFilter();
    setShowSaveFilterModal(false);
    document.body.click();
  };

  const deleteFilter = () => {
    props.deleteSavedFilter(selectedFilterIndex, reward_type);
    setSelectedFilterIndex(-1);
    setColumns(initialColumns);
  };

  return (
    isFilterApplied(columns) && (
      <>
        <hr className="mb-0" />
        <div className="d-flex flex-wrap align-items-center">
          <div className="d-flex flex-wrap align-items-center">
            {renderFilterChips()}
          </div>
          <div className="d-flex mt-16">
            {showDelete ? (
              <Typography.ButtonText
                className="mb-0 cursor-pointer"
                color="red"
                shade="c200"
                onClick={() => {
                  deleteFilter();
                }}
              >
                Delete
              </Typography.ButtonText>
            ) : (
              <>
                {!["payments"].includes(title) &&
                  type === "xoxo_token_report" &&
                  title !== "xoxo reward link" && (
                    <Typography.ButtonText
                      color="primary"
                      shade="c04"
                      className={`mr-12 mb-0 cursor-pointer ${
                        reportsData?.length > 0 && !hideReportOptions
                          ? ""
                          : "disabled"
                      }`}
                      onClick={() => {
                        setShowSaveFilterModal(true);
                      }}
                    >
                      Save
                    </Typography.ButtonText>
                  )}
                <Typography.ButtonText
                  className="mb-0 cursor-pointer"
                  color="red"
                  shade="c200"
                  onClick={() => handleResetFilter()}
                >
                  Clear All
                </Typography.ButtonText>
              </>
            )}
          </div>
        </div>
        <Modal
          isOpen={showSaveFilterModal}
          onClose={() => {
            setShowSaveFilterModal(false);
          }}
          disableCloseButton={false}
          size="sm"
          onOverlayClick={() => {
            return false;
          }}
        >
          <Typography.H3>Save Filter</Typography.H3>
          <Typography color="dark" shade="c200">
            Name your filter for quick viewing
          </Typography>
          <Input
            className="mt-4 mb-20"
            label="Filter Name"
            onChange={(e) => {
              setSaveFilterName(e.target.value);
            }}
            placeholder="Enter a filter name"
          />
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              color="primary"
              variant="plain"
              mr="1"
              onClick={() => {
                setShowSaveFilterModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              variant="fill"
              disabled={saveFilterName === ""}
              onClick={saveFilter}
            >
              Save
            </Button>
          </div>
        </Modal>
      </>
    )
  );
};

const mapStateToProps = (state) => {
  const { reportReducer: { filterLoader = false } = {} } = state;
  return {
    filterLoader,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSavedFilter: (reward_type) => fetchSavedFilter(reward_type),
      addFilterByThunk: (params, reward_type) =>
        addFilterByThunk(params, reward_type),
      deleteSavedFilter: (activeIndex, reward_type) =>
        deleteSavedFilter(activeIndex, reward_type),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AppliedFilters);
